<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="资讯生成列表">
        <div style="background: #ffffff; position: relative">
          <div class="search-condition-con" :class="'show'">
            <div class="search-condition">
              <span class="label">模板名称</span>
              <div class="input-condition">
                <el-input
                  v-model="condition.template_name"
                  maxlength="30"
                  placeholder="请输入关键词查询"
                ></el-input>
              </div>
            </div>
            <div class="search-condition">
              <span class="label">类型</span>
              <div class="input-condition">
                <el-select v-model="condition.type_id" placeholder="全部">
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="search-condition">
              <span class="label">站点</span>
              <div class="input-condition">
                <site-auto-complete
                  v-model="condition.site"
                  :clueId="1"
                  :init-choose-first="false"
                  :owned="true"
                  ref="siteAutoComplete"
                  @created="initData"
                  clearable
                ></site-auto-complete>
              </div>
            </div>
            <div
              class="search-condition search-condition-time"
              style="min-width: 400px"
            >
              <span class="label">生成时间</span>
              <div class="input-condition">
                <el-date-picker
                  v-model="condition.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  @change="condition.timestamp = ''"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="btn-condition">
            <el-button type="primary" @click="handleSearch()">查 询</el-button>
            <el-button @click="resetSearch()">清空条件</el-button>
            <el-button-group class="floatR" style="margin-left: 20px">
              <el-tooltip
                class="item"
                effect="dark"
                content="导出"
                placement="top"
                v-permission="'operating.news-model-manage.news-list.news-export'"
              >
                <el-button
                  icon="el-icon-download"
                  @click="exportList"
                ></el-button>
              </el-tooltip>
            </el-button-group>
          </div>
        </div>
        <el-table
          :data="list"
          style="width: 100%"
          :highlight-current-row="true"
          stripe
          tooltip-effect="dark"
          ref="multipleTable"
          v-loading="isLoading"
          header-cell-class-name="table-back"
          class="list-table"
        >
          <el-table-column label="模板名称" prop="name" align="center"></el-table-column>
          <el-table-column label="文章类型" prop="type_name" align="center"></el-table-column>
          <el-table-column label="站点" prop="site_name" align="center"></el-table-column>
          <el-table-column label="文章标题" prop="desc" align="center">
           <template slot-scope="scope">
            <a :href="scope.row.news_url" target="_blank" style="color:#0099FF;">{{scope.row.desc}}</a>
          </template>
          </el-table-column>
          <el-table-column label="生成时间" prop="execute_time_full" align="center" ></el-table-column>
        </el-table>
        <template v-if="list.length > 0">
          <el-pagination
            background
            layout="total,prev, pager, next"
            :current-page="condition.page"
            :total="condition.total"
            :page-size="condition.per_page"
            @current-change="currentChange"
          ></el-pagination>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { NewsCreatedlList, exportNewsList } from "@/service/newsModel";
import { NEWS_MODEL } from "@/config/index";
import SiteAutoComplete from "@/components/auto-complete/site-auto-complete";
export default {
  components:{
    SiteAutoComplete
  },
  data() {
    return {
      typeList: [],
      list: [],
      condition: {
        type_id: "",
        template_name: "",
        site: "",
        time: "",
        per_page: 10,
        total: 0,
        page: 1,
      },
      isLoading: false,
    };
  },
  mounted() {
    this.typeList = NEWS_MODEL.news_types;
  },
  methods: {
    handleSearch() {
      this.condition.page = 1;
      this.initData();
    },
    resetSearch() {
      this.condition = {
        type_id: "",
        template_name: "",
        site: "",
        time: "",
        per_page: 10,
        total: 0,
        page: 1,
      };
      this.initData();
    },
    async initData() {
      this.list = [];
      let query = {
        type_id: this.condition.type_id,
        template_name: this.condition.template_name,
        site: this.condition.site,
        per_page: this.condition.per_page,
        total: this.condition.total,
        page: this.condition.page,
      }
      if (this.condition.time && this.condition.time.length > 1) {
        query.execute_time_start = Date.parse(new Date(this.condition.time[0])) / 1000;
        query.execute_time_end = Date.parse(new Date(this.condition.time[1])) / 1000;
      }else{
        delete query.execute_time_start;
        delete query.execute_time_end;
      }
      await NewsCreatedlList(query).then((data) => {
        this.condition.total = data.total;
        this.list = data.data;
      });

      //数据请求完毕取消当前页面的loading
      this.isLoading = false;
    },
    currentChange(index) {
      this.condition.page = index;
      this.initData();
    },
    async exportList() {
      if(!this.list.length){
        this.$message({
            message: "请先查询需要导出的数据",
            type: 'error',
            duration: 3 * 1000
         })
        return 
      }
      import("@/vendor/Export2Excel").then(async (excel) => {
        const tHeader = [
          "模板名称",
          "文章类型",
          "站点",
          "文章标题",
          "文章链接",
          "生成时间",
        ];
        const filterVal = [
          "name",
          "type_name",
          "site_name",
          "desc",
          "news_url",
          "execute_time_full",
        ];
        let list = [];
        let query = {
          site: this.condition.site,
          template_name: this.condition.template_name,
          type_id: this.condition.type_id,
        };
        if (this.condition.time && this.condition.time.length > 0) {
          query.execute_time_start = Date.parse(new Date(this.condition.time[0])) / 1000;
          query.execute_time_end = Date.parse(new Date(this.condition.time[1])) / 1000;
        } else {
          this.$message({
            message: "请选择时间段",
            type: "error",
            duration: 3 * 1000,
          });
          return;
        }
        this.isLoading = true;
        // 导出接口请求数据....
        await exportNewsList(query).then((data) => {
          let listData = data.data;
          list = listData;
        });
        const formatJson = (filterVal) => {
          return list.map((v) =>
            filterVal.map((j) => {
              return v[j];
            })
          );
        };
        const data = formatJson(filterVal);
        const filename = "资讯生成列表" + this.condition.time[0].slice(0,10) + "至" + this.condition.time[1].slice(0,10)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: filename,
        });
        this.isLoading = false;
      });
    },
  },
};
</script>
<style lang="less" scoped>
</style>